import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service'; // Assume AuthService handles login/logout/token regeneration
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  OToken:any;
  constructor(private authService: AuthService,private http:HttpClient,private router: Router) {
    this.OToken = localStorage.getItem('Otoken')

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/login') || req.url.includes('/forgot-password') || req.url.includes('/playlist')) {
      return next.handle(req);
    }
    if (this.OToken) {
        // Set the Authorization header with OToken if it exists
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${this.OToken}`
          }
        });
      }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400) {
          
          if (error.error.message === "Token is invalid") {
            // Logout for invalid token
            localStorage.clear();
            this.router.navigate(['/add-playlist']);
            window.location.reload()
          } 
          else if (error.error.message === "Token expired") {
            // Regenerate token and retry the request
            return this.authService.regenerateToken().pipe(
              switchMap(newToken => {
                // Clone the request with new token
                const clonedRequest = req.clone({
                  setHeaders: { Authorization: `Bearer ${newToken}` }
                });
                return next.handle(clonedRequest);
              })
            );
          }
          else if(error.error.msg == 'Maximum number of profiles reached for this playlist. Please delete an existing profile before adding a new one.'){
            this.authService.showErrorToast(error.error.msg)
          }
          else if(error.error.message == "Validation failed"){
            const emailError = error.error.errors?.email?.[0];
            this.authService.showErrorToast(emailError)
          }
          
        }
        else if(error.status === 404){
            // localStorage.clear();
            // this.router.navigate(['/add-playlist']);
            // window.location.reload()
            if(error.error.msg == "Profile not found"){
              this.authService.showErrorToast(error.error.msg);
            }
        }
        else if(error.status === 521){
            localStorage.clear();
            this.router.navigate(['/add-playlist']);
            window.location.reload()
        }
        else if(error.status === 409){
          this.authService.showErrorToast(error.error.error)

        }else if(error.status === 401){
          if(error.error.msg=="Token has expired"){
            const storedUser = JSON.parse(localStorage.getItem('userData') || '{}');
            if (storedUser?.user_id) {
              const loginData = {
                username: storedUser.user_id,
                password: 'purpleapp'
              };
              console.log(loginData);
               return this.http.post(`${environment.mediaBaseUrl}/login`,loginData).pipe(
                switchMap((res: any) => {
                  if (res?.access_token) {
                    localStorage.setItem('mtoken', res.access_token);
                    window.location.reload()
                    const cloned = req.clone({
                      setHeaders: { Authorization: `Bearer ${res.access_token}` }
                    });
                    return next.handle(cloned);
                  }
                  return throwError(() => error);
                })
              );
            
          }
        }}
        
        return throwError(() => error);
      })
    );
  }
}
